var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" " + _vm._s(_vm.name) + " ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                staticClass: "text-center body-1"
              },
              [
                _c("v-img", {
                  staticClass: "ma-auto",
                  attrs: {
                    src: _vm.imagePath,
                    "max-height": "64",
                    contain: ""
                  }
                }),
                _c("p", {
                  staticClass: "mt-6",
                  domProps: {
                    innerHTML: _vm._s(_vm.description)
                  }
                }),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.website,
                      target: "_blank"
                    }
                  },
                  [_vm._v("Visit Plugin Website")]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                staticClass: "mx-auto",
                attrs: {
                  primary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v(" Close ")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }